import { render, staticRenderFns } from "./ExpectedDeliveryDateChangeForm.vue?vue&type=template&id=55e32700&scoped=true"
import script from "./ExpectedDeliveryDateChangeForm.vue?vue&type=script&lang=js"
export * from "./ExpectedDeliveryDateChangeForm.vue?vue&type=script&lang=js"
import style0 from "./ExpectedDeliveryDateChangeForm.vue?vue&type=style&index=0&id=55e32700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e32700",
  null
  
)

export default component.exports